module.exports = __webpack_public_path__ + "static/media/Nubilux709Argent.dbb71aee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/Nubilux709Argent.jpg
// module id = 28
// module chunks = 0